import { useState, type FormEvent } from 'react';
import { api } from '../api';
import { AvisoError } from '../componentes';
import { useCola } from '../hooks';
import { reanudarTrasReconectar } from '../offline/cola';

export function ConectarGextia({
  motivo,
  alConectar,
}: {
  motivo?: string;
  alConectar: () => void;
}) {
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [enviando, setEnviando] = useState(false);
  const cola = useCola();

  async function enviar(evento: FormEvent) {
    evento.preventDefault();
    setEnviando(true);
    setError(null);
    try {
      await api.conectarGextia(apiKey.trim());
      // Lo que quedó parado por la clave vieja se reanuda solo. Es la diferencia
      // entre "he perdido los tickets" y "ya está".
      await reanudarTrasReconectar();
      alConectar();
    } catch (fallo) {
      setError(fallo);
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="pantalla-centrada" style={{ textAlign: 'left' }}>
      <h2>Conecta tu Gextia</h2>

      {cola.pendientes > 0 && (
        <p className="aviso info">
          Tienes {cola.pendientes} {cola.pendientes === 1 ? 'cosa' : 'cosas'} esperando a
          subir. No se han perdido: saldrán en cuanto reconectes.
        </p>
      )}

      {motivo ? (
        <p className="aviso atencion">{motivo}</p>
      ) : (
        <p>
          Las notas se crean a tu nombre, así que necesitamos tu clave personal. Se
          guarda cifrada y solo se usa para escribir tus gastos.
        </p>
      )}

      <details>
        <summary style={{ cursor: 'pointer', fontWeight: 600 }}>
          ¿De dónde saco la clave?
        </summary>
        <ol style={{ paddingLeft: '1.2rem', color: 'var(--tinta-suave)' }}>
          <li>Entra en Gextia desde el ordenador.</li>
          <li>
            Arriba a la derecha, en tu nombre → <strong>Preferencias</strong>.
          </li>
          <li>
            Pestaña <strong>Seguridad de la cuenta</strong> → <strong>Nueva clave API</strong>.
          </li>
          <li>Cópiala y pégala aquí. Solo se muestra una vez.</li>
        </ol>
      </details>

      <form onSubmit={enviar} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <div className="campo">
          <label htmlFor="apikey">Clave API</label>
          <input
            id="apikey"
            type="password"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            autoComplete="off"
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck={false}
            placeholder="Pega aquí tu clave"
            required
          />
        </div>

        <AvisoError error={error} />

        <button type="submit" className="boton ancho" disabled={enviando || !apiKey.trim()}>
          {enviando ? 'Comprobando…' : 'Conectar'}
        </button>
      </form>
    </div>
  );
}
